import React from 'react';
import { ChevronDown, Activity } from 'lucide-react';
import { Timeframe } from '../data/mockData';
interface DashboardHeaderProps {
  timeframe: Timeframe;
  setTimeframe: (timeframe: Timeframe) => void;
}
export function DashboardHeader({
  timeframe,
  setTimeframe
}: DashboardHeaderProps) {
  const timeframes: Timeframe[] = ['Today', 'Last 7 Days', 'Last 30 Days', 'Month to Date', 'Custom Range'];
  return <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center py-6 px-6 bg-slate-900/50 border-b border-slate-800 sticky top-0 z-10 backdrop-blur-sm" data-id="element-27">
      <div className="flex items-center gap-3 mb-4 sm:mb-0" data-id="element-28">
        <div className="p-2 bg-cyan-500/20 rounded-lg border border-cyan-500/30" data-id="element-29">
          <Activity className="w-6 h-6 text-cyan-400" data-id="element-30" />
        </div>
        <div data-id="element-31">
          <h1 className="text-2xl font-bold text-white tracking-tight" data-id="element-32">
            Loan Officer War Room
          </h1>
          <p className="text-sm text-slate-400" data-id="element-33">Performance Command Center</p>
        </div>
      </div>

      <div className="relative group" data-id="element-34">
        <select value={timeframe} onChange={e => setTimeframe(e.target.value as Timeframe)} className="appearance-none bg-slate-800 border border-slate-700 text-white py-2 pl-4 pr-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-transparent cursor-pointer font-medium shadow-sm hover:bg-slate-750 transition-colors" data-id="element-35">
          {timeframes.map(tf => <option key={tf} value={tf} data-id="element-36">
              {tf}
            </option>)}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none group-hover:text-white transition-colors" data-id="element-37" />
      </div>
    </header>;
}